import { render, staticRenderFns } from "./GenerarCodigosPaquetes.vue?vue&type=template&id=5f5aeb1c"
import script from "./GenerarCodigosPaquetes.vue?vue&type=script&lang=js"
export * from "./GenerarCodigosPaquetes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports